<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
            <el-form-item :label="$t('public.table_scope')" prop="sceneId" v-if="sysAdmin === 'isSysAdmin' || sysAdmin === 'isSysNoAdmin'">
                <el-select v-model="dioForm.sceneId" style="width: 250px">
                    <el-option v-for="item in scopeArrays" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('integration.relay_type')" prop="type">
                <el-select v-model="dioForm.type" style="width: 250px">
                    <el-option v-for="item in typeArray" :key="item.id" :label="`${$t(deviceTypeListConvert[item.code])}`"
                     :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('integration.trunk_number')" prop="relayCode">
                <el-input v-model.trim="dioForm.relayCode" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('integration.relay_nickname')" prop="nickname">
                <el-input v-model.trim="dioForm.nickname" style="width: 250px" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
                <el-input v-model.trim="dioForm.extPanId" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('Join Attemp')" prop="channelPage">
                <el-input v-model="dioForm.channelPage" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
                <el-input v-model.trim="dioForm.channelMask" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.transmit_power')" prop="transmitPower">
                <el-input v-model.trim="dioForm.transmitPower" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.in_net_interval')" prop="inNetInterval">
                <el-input v-model.trim="dioForm.inNetInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('public.table_desc')" prop="description">
                <el-input
                    v-model.trim="dioForm.description"
                    style="width: 250px"
                    type="textarea"
                    maxlength="250"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    show-word-limit
                    :placeholder="$t('public.please_enter')"
                />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { relayAddRelay, relayEditRelay } from '@/api/modules/relay.js';
import { addNetRules } from '../validate/addRules';
import { deviceTypeListConvert } from '@/utils/convert'

export default {
    props: ['isShow', 'title', 'scopeArray', 'editRow', 'typeArray'],
    watch: {
        scopeArray(newVal) {
            this.scopeArrays = [...newVal];
        },
        editRow(newVal) {
            const { sceneId, type, relayCode, description, extPanId, channelPage, channelMask, transmitPower, inNetInterval, id, nickname } = newVal;

            this.dioForm = {
                id,
                sceneId: String(sceneId),
                extPanId,
                channelPage,
                type,
                relayCode,
                description,
                channelMask,
                transmitPower,
                inNetInterval,
                nickname
            };
        }
    },
    computed: {
        deviceTypeListConvert: () => deviceTypeListConvert,

        /** 用于表示当前登录用户属于什么类型的角色 */
        sysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            if (currentUser.sysScope && currentUser.sysAdmin) {
                //系统管理员
                return 'isSysAdmin';
            } else if (currentUser.sysScope && !currentUser.sysAdmin) {
                //系统非管理员
                return 'isSysNoAdmin';
            } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
                //非系统管理员 以及代理角色  代理角色是迭代7的需求添加
                return 'noSysIsAdmin';
            } else {
                //非系统非管理员
                return 'noSysNoAdmin';
            }
        },
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        },
        rules() {
            return {
                sceneId: [{ required: true, message: $t('integration.range_cannot_be_empty'), trigger: 'change' }],
                type: [{ required: true, message: $t('integration.relay_type_cannot_be_empty'), trigger: 'change' }],
                relayCode: [
                    { required: true, message: $t('integration.relay_number_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 50,
                        message: $t('integration.the_length_of_trunk_number_cannot_be_greater_than_50'),
                        trigger: 'blur'
                    }
                ],
                nickname: [{ required: true, message: $t('integration.relay_nickname_cannot_be_empty'), trigger: 'blur' }],
                ...addNetRules(['extPanId', 'channelPage', 'channelMask', 'transmitPower', 'inNetInterval'])
            };
        }
    },
    created() {},
    data() {
        return {
            dioForm: {
                sceneId: '',
                type: '',
                code: '',
                relayCode: '',
                description: '',
                channelMask: '11',
                extPanId: '50414e4944303032',
                channelPage: '0',
                transmitPower: '17',
                inNetInterval: '900',
                nickname: ''
            },
            scopeArrays: [],
            relayType: ''
        };
    },
    methods: {
        relayTypeChange(item) {
            this.dioForm.code = item.code;
            this.dioForm.type = item.type;
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        async handleSave() {
            const { type, typeCode } = this.editRow;
            const res = this.typeArray.filter(item => item.id === this.dioForm.type);
            this.dioForm.typeCode = res.length && res[0].code;

            let flag = await this.justify();
            if (!flag) return;
            let httpUrl = relayAddRelay;
            if (this.dioForm.id) {
                httpUrl = relayEditRelay;
            }

            this.dioForm['sceneId'] = this.dioForm['sceneId'] || this.$store.state.userInfo.scope['sceneId'];

            // this.dioForm['type']=
            httpUrl(this.dioForm).then(({ state }) => {
                if (state.code === 200) {
                    this.$message.success(this.dioForm.id ? this.$t('public.tip_edit_succ') : this.$t('public.tip_add_succ'));
                    this.isShowDialog = false;
                    this.$parent.getListFn();
                } else {
                    this.$message.error(state.msg);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
    border-radius: 2px;
    margin-left: 5px;
}
</style>
